module.exports = __webpack_public_path__ + "static/media/8.44a62055.jpg";